// Reactインポート
import React from "react";
import { Link } from "react-router-dom";

// ヘッダースタイル
import "../css/Footer.scss";

// アイコンイメージ
import contactRequestImg from "../img/common/contact.png";

// footerロゴ
import footerLogo from "../img/footer/logo.png";

function Footer() {
  return (
    <footer>
      <div className="footer-section-contents">
        <div className="sitemap-desc">
          <div className="footer-logo">
            <img src={footerLogo} alt="" />
          </div>
          <ul className="sub-menu">
            {/* <li>サイトマップ</li>
						<li>プライバシーポリシー</li>
						<li>制作依頼について</li> */}
          </ul>
          <ul className="main-menu">
            <Link to="/">
              <li>TOP</li>
            </Link>
            <Link to="/about">
              <li>ABOUT</li>
            </Link>
            {/* <li>SERVICES</li> */}
            <Link to="/works">
              <li>WORKS</li>
            </Link>
            <Link to="/portfolio">
              <li>PORTFOLIO</li>
            </Link>
            <Link to="/packages">
              <li>PACKAGES</li>
            </Link>
            {/* <li>PACKAGES</li> */}
            <Link to="/contactform">
              <li>CONTACT</li>
            </Link>
          </ul>
        </div>
        <div className="contact-desc">
          <div className="contact-txt">
            ホームページ制作の見積もり依頼や、パートナーシップ、その他サービスに関するお問い合わせは、当サイトのお問い合わせフォームより必要事項をご入力のうえお寄せください。お問い合わせいただいた内容により、回答までにお時間を頂戴することもございますのであらかじめご了承ください。
          </div>
          <div className="contact-button">
            <Link to="/contactform">
              <div className="button1 btn-con">
                <img src={contactRequestImg} alt=""></img>
                <text>無料相談</text>
              </div>
            </Link>
          </div>
          <div className="contact-tel">
            <a href="tel:043-356-0300">043-356-0300</a>
            <text>
              ※外出のため、お電話に出れない場合がございます。大変お手数をおかけしますが、メールにて再度お問い合わせください。
            </text>
          </div>
          {/* <div className="footer-banner">バナー</div> */}
        </div>
      </div>
      <div className="copyright">Copyright© SMARTGENZ ALL RIGHTS RESERVED.</div>
    </footer>
  );
}

export default Footer;
